// More robust version for live site with Shopify scripts
if (!customElements.get("main-hero")) {
  customElements.define(
    "main-hero",
    class MainHero extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        this._trackInView = this._trackInView.bind(this);
        
        this.elements = {
          content: this.querySelector(".hero__content"),
          products: this.querySelector(".hero__products"),
          viewport: this.querySelector(".hero__viewport"),
          background: this.querySelector(".hero__background")
        };
        
        this._track = this;
        this._pin = this.elements.viewport;
        
        // Set initial progress as string
        this.style.setProperty("--hero-progress", "0");
        
        // Wait for next tick to ensure Shopify scripts have started loading
        // This gives us a cleaner animation start on live sites
        setTimeout(() => {
          // Then use double RAF for smooth start
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this._initAutoAnimation();
              this._initScrollHeaderTrigger();
              this._scaleText();
              this._play();
            });
          });
        }, 0);
      }
      
      _play() {
        this.setAttribute("play", true);
      }
      
      _scaleText() {
        const contentHeight = this.elements.content?.offsetHeight || 0;
        const productsHeight = this.elements.products?.offsetHeight || 0;
        const headerHeight = parseFloat(getComputedStyle(this).getPropertyValue("--header-height")) * 16;
        if (contentHeight + productsHeight > window.innerHeight - headerHeight) {
          const scale = (window.innerHeight - headerHeight) / (contentHeight + productsHeight);
          this.style.setProperty("--hero-scale", scale);
        }
      }
      
      _trackInView(progress) {
        // Set progress on main element
        this.style.setProperty("--hero-progress", progress);
        
        // Ensure background gets the progress value too
        if (this.elements.background) {
          this.elements.background.style.setProperty("--hero-progress", progress);
        }
        
        this._lastProgress = progress;
      }
      
      _initAutoAnimation() {
        const duration = 3500; // 3.5 seconds total
        const delay = 300; // Start after 300ms
        
        setTimeout(() => {
          let startTime = null;
          
          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            
            const elapsed = timestamp - startTime;
            const linearProgress = Math.min(elapsed / duration, 1);
            
            // Apply smooth easing
            const progress = this._easeInOutCubic(linearProgress);
            
            // Update animation progress only
            this._trackInView(progress);
            
            // Continue until complete
            if (linearProgress < 1) {
              requestAnimationFrame(animate);
            }
          };
          
          requestAnimationFrame(animate);
        }, delay);
      }
      
      _initScrollHeaderTrigger() {
        let ticking = false;
        
        const updateHeader = () => {
          const scrolled = window.scrollY > 30;
          const header = document.querySelector('.site-header--home');
          
          if (header) {
            if (scrolled) {
              header.classList.add('site-header--home-scrolled');
            } else {
              header.classList.remove('site-header--home-scrolled');
            }
          }
          ticking = false;
        };
        
        // Check initial scroll position
        updateHeader();
        
        // Add scroll listener
        window.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(updateHeader);
            ticking = true;
          }
        });
      }
      
      _easeInOutCubic(t) {
        return t < 0.5 
          ? 4 * t * t * t 
          : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
    }
  );
}